export class ChangePassword {

    public OldPassword?:any;
    public NewPassword?:any;
    public ConfirmPassword?:any;

}
